import { Helmet } from 'react-helmet-async'

import config from '@app/config'

export const IosBannerHeader = () => {
  const pathname = window.location.pathname.startsWith('/') 
    ? window.location.pathname.slice(1) 
    : window.location.pathname
  const appUrl =  `${config.apps.ios.protocol}://${pathname}`
  return (
    <>
      <Helmet>
        <meta
          name="apple-itunes-app"
          content={`app-id=${config.apps.ios.id}, app-argument=${appUrl}, affiliate-data=ct=smart_banner`}
        />
      </Helmet>
    </>
  )
}